import { useParams } from "react-router-dom";
import React from "react";
import {
  DATE_TIME_PICKER_OPTIONS,
  MONEY_HISTORY_CURRENCY_TYPES_OPTIONS,
} from "../../../constants";
import { ServerDataGrid } from "../../../components/CustomDataGrid";
import {
  AccountMovementCell,
  BalanceCell,
  DateCell,
  DateRangeFilter,
  SimpleSelectCell,
} from "../../../components/CustomCells";

const columns = [
  {
    accessorKey: "currencyType",
    filterVariant: "multi-select",
    header: "Currency",
    Cell: SimpleSelectCell,
    operator: "contains",
  },
  {
    accessorKey: "currencyDifference",
    filterVariant: "range",
    header: "Account Movement",
    Cell: AccountMovementCell,
    operator: "betweenInclusive",
  },
  {
    accessorKey: "balance",
    filterVariant: "range",
    header: "Balance",
    Cell: BalanceCell,
    operator: "betweenInclusive",
  },
  {
    accessorKey: "matchId",
    filterVariant: "text",
    header: "Source",
    operator: "equals",
  },
  {
    accessorKey: "eventType",
    filterVariant: "multi-select",
    header: "Event Type",
    Cell: SimpleSelectCell,
    operator: "contains",
  },
  {
    accessorKey: "transactionId",
    filterVariant: "text",
    header: "Event ID",
    operator: "equals",
  },
  {
    accessorKey: "createdAt",
    type: "dateTime",
    header: "Event Date",
    Cell: DateCell,
    sortingFn: "datetime",
    Filter: DateRangeFilter,
    operator: "betweenInclusive",
  },
];

function UserMoneyHistory() {
  const { userId } = useParams();
  const moneyHistoryApiUrl = `/api/v1/users/${userId}/money-history`;

  return (
    <ServerDataGrid
      columns={columns}
      dateTimeFilterFields={[
        {
          accessorKey: "currencyType",
          title: "Currency Type",
          options: MONEY_HISTORY_CURRENCY_TYPES_OPTIONS,
        },
        {
          accessorKey: "createdAt",
          title: "Event Date",
          options: DATE_TIME_PICKER_OPTIONS,
        },
      ]}
      apiUrl={moneyHistoryApiUrl}
    />
  );
}

export default UserMoneyHistory;
